var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRole({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1688988795450,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 3796,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M928 400A240 240 0 0 0 567.68 192a224 224 0 1 0-366.4 256l-3.52 3.2-15.68 13.76-5.12 5.44-12.8 14.08-4.16 8.32-10.88 14.4-5.12 7.68-8.96 15.04-7.04 8.64-8.32 16.96-3.2 7.68c-2.24 5.44-4.16 10.56-6.72 18.24 0 2.56 0 5.12-2.56 7.68s-2.88 11.2-4.8 19.2l-1.92 7.68c0 6.08-1.92 12.16-3.2 21.12V896h312.64A96 96 0 0 0 480 928h352a96 96 0 0 0 96-96v-288a96 96 0 0 0-17.28-54.72A235.84 235.84 0 0 0 928 400z",
    fill: "#FFFFFF",
    "p-id": 3797
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M688 400m-208 0a208 208 0 1 0 416 0 208 208 0 1 0-416 0Z",
    fill: "#e6e6e6",
    "p-id": 3798
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M384 416a256 256 0 0 1 256 256v192H128v-192a256 256 0 0 1 256-256z",
    fill: "#c3ffeb",
    "p-id": 3799
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M352 450.56v-32A256 256 0 0 0 128 672v192h224v-32H160v-160a224 224 0 0 1 192-221.44z",
    fill: "currentColor",
    "p-id": 3800
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M384 320m-192 0a192 192 0 1 0 384 0 192 192 0 1 0-384 0Z",
    fill: "#FFFFFF",
    "p-id": 3801
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M384 160a160 160 0 1 1-160 160 160 160 0 0 1 160-160m0-32a192 192 0 1 0 192 192 192 192 0 0 0-192-192z",
    fill: "currentColor",
    "p-id": 3802
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M416 480m64 0l352 0q64 0 64 64l0 288q0 64-64 64l-352 0q-64 0-64-64l0-288q0-64 64-64Z",
    fill: "#FFFFFF",
    "p-id": 3803
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M480 480h352a64 64 0 0 1 64 64v64H416v-64a64 64 0 0 1 64-64z",
    fill: "#c3ffeb",
    "p-id": 3804
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M832 512a32 32 0 0 1 32 32v288a32 32 0 0 1-32 32H480a32 32 0 0 1-32-32v-288a32 32 0 0 1 32-32h352m0-32H480a64 64 0 0 0-64 64v288a64 64 0 0 0 64 64h352a64 64 0 0 0 64-64v-288a64 64 0 0 0-64-64z",
    fill: "currentColor",
    "p-id": 3805
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M832 576H480v32h352v-32zM576 672h-96v32h96v-32zM832 768h-96v32h96v-32zM832 672h-224v32h224v-32z",
    fill: "currentColor",
    "p-id": 3806
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M608 672v32h-32v-32h32m32-32h-96v96h96v-96zM704 768h-224v32h224v-32z",
    fill: "currentColor",
    "p-id": 3807
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M736 768v32h-32v-32h32m32-32h-96v96h96v-96z",
    fill: "currentColor",
    "p-id": 3808
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/role.bf5d94e94766a73c8ae278718238f9a7.svg";
export { ForwardRef as ReactComponent };